function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "usps");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M211.75,27A4.25,4.25,0,1,0,216,31.2,4.19,4.19,0,0,0,211.75,27Zm0,7.89a3.64,3.64,0,1,1,3.58-3.64A3.56,3.56,0,0,1,211.75,34.84Z",
  transform: "translate(0 0)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M213.69,30.11c0-.88-.48-1.36-1.6-1.36h-1.89v4.91h.61V31.48h1l1.38,2.18h.71l-1.46-2.18A1.32,1.32,0,0,0,213.69,30.11Zm-2.08.86h-.8v-1.7h1.11c.59,0,1.16.16,1.16.85S212.35,31,211.61,31Z",
  transform: "translate(0 0)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M7.69.17s30.39,6.25,31,6.35c7,1.23,6.77,2.58,6.77,2.58,4.89,0,5.49.17,6.35.88,2.57,2.15-1.61,8.48-1.61,8.48-.6.45-45.8,17.91-45.8,17.91H50.61L58.35,0H7.72Z",
  transform: "translate(0 0)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M48.9,16.62a11.48,11.48,0,0,0,1.65-3.73c.19-1.64-1.21-1.89-3.16-1.89H44.3c-.16,0-.29.11-.48.36a1.81,1.81,0,0,1-.75.59,13.22,13.22,0,0,1-3.31.6c-.81.07-1,.15-1,.46s.12.44,1.28.44c2.66,0,7.44-1,8.88-.54.76.24.14,1.6-.47,3.38C48.16,17,48.63,16.92,48.9,16.62Z",
  transform: "translate(0 0)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M37.09,18.89a81.7,81.7,0,0,1,8.63-2.33c1.08-.19,1.53-.37,1.52-.57,0-.57-1.11-.61-2.94-.52C38.72,15.72,28,20,25,21.59L21.49,10.84H43.67c1-2.79-13.13-2.4-13.57-2.43H5.94L0,36.38s18.19-8.93,20.41-10.07A132.61,132.61,0,0,1,37.09,18.89Z",
  transform: "translate(0 0)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M68.71,14.2c3.33,0,5.86-1.34,6.5-4.3,1.85-8.56,0,0,1.85-8.56H74.27L72.62,9.06c-.42,2-1.46,3.15-3.5,3.15S66.55,11,67,9.06c-.05.2,1.65-7.71,1.65-7.71H65.86S65.13,4.78,64,9.9C63.39,12.86,65.38,14.2,68.71,14.2Z",
  transform: "translate(0 0)"
});

var _ref9 = /*#__PURE__*/React.createElement("polygon", {
  points: "79.52 13.97 81.47 4.61 81.52 4.61 84.64 13.97 88.14 13.97 90.82 1.34 88.36 1.34 86.37 10.81 86.33 10.81 83.34 1.34 79.73 1.34 77.05 13.97 79.52 13.97"
});

var _ref10 = /*#__PURE__*/React.createElement("polygon", {
  points: "93.6 13.97 96.28 1.34 93.5 1.34 90.82 13.97 93.6 13.97"
});

var _ref11 = /*#__PURE__*/React.createElement("polygon", {
  points: "99.38 13.97 102.16 13.97 104.41 3.35 108.34 3.35 108.76 1.34 98.15 1.34 97.7 3.35 101.63 3.35 99.38 13.97"
});

var _ref12 = /*#__PURE__*/React.createElement("polygon", {
  points: "117.09 13.97 117.52 11.96 111.16 11.96 111.88 8.51 117.43 8.51 117.83 6.64 112.29 6.64 112.99 3.35 119.35 3.35 119.77 1.34 110.63 1.34 107.94 13.97 117.09 13.97"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M124.83,14a7.7,7.7,0,0,0,7.66-6.87c.55-3.22-.74-5.76-4.56-5.76H121.8L119.12,14Zm-.65-10.62H127c2.31,0,3.13,1.71,2.78,3.72C129.3,9.9,127.49,12,124.34,12h-2Z",
  transform: "translate(0 0)"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M145.21,11c.51-3.1-4.93-4.7-4.51-6.71.14-.62.82-.93,2.34-.93h3l.44-2h-3.73c-3.28,0-4.9,1.16-5.14,3-.4,3,5,4.82,4.55,6.63-.25,1.06-1.55,1-2.61,1h-3.44l-.42,2h4.26C143.42,14,144.93,12.72,145.21,11Z",
  transform: "translate(0 0)"
});

var _ref15 = /*#__PURE__*/React.createElement("polygon", {
  points: "149.12 13.97 151.91 13.97 154.16 3.35 158.09 3.35 158.51 1.34 147.9 1.34 147.45 3.35 151.38 3.35 149.12 13.97"
});

var _ref16 = /*#__PURE__*/React.createElement("polygon", {
  points: "157 13.97 162.56 3.85 163.66 11.96 159.68 11.96 158.59 13.97 166.76 13.97 164.79 1.34 161.46 1.34 154.23 13.97 157 13.97"
});

var _ref17 = /*#__PURE__*/React.createElement("polygon", {
  points: "169.09 13.97 171.88 13.97 174.13 3.35 178.06 3.35 178.48 1.34 167.86 1.34 167.42 3.35 171.35 3.35 169.09 13.97"
});

var _ref18 = /*#__PURE__*/React.createElement("polygon", {
  points: "186.79 13.97 187.22 11.96 180.86 11.96 181.58 8.51 187.13 8.51 187.53 6.64 181.99 6.64 182.69 3.35 189.04 3.35 189.47 1.34 180.33 1.34 177.63 13.97 186.79 13.97"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M195,11c-.25,1.06-1.55,1-2.61,1H189l-.42,2h4.26c3.49,0,5-1.25,5.28-3,.51-3.1-4.93-4.7-4.51-6.71.14-.62.83-.93,2.34-.93h3l.44-2h-3.73c-3.28,0-4.9,1.16-5.15,3C190,7.35,195.4,9.14,195,11Z",
  transform: "translate(0 0)"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M67.43,22.39h-6L58.71,35H61.5L63.75,24.4H66c1,0,1.72.51,1.43,1.89a2.61,2.61,0,0,1-2.75,2.06c-.42,0-.88-.05-1.23-.08l.14,1.83c.4,0,.88.11,1.32.11a5.08,5.08,0,0,0,5.21-3.85C70.48,24.77,70.16,22.39,67.43,22.39Z",
  transform: "translate(0 0)"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M79.09,22.16A7.76,7.76,0,0,0,71,28.7a5.14,5.14,0,0,0,5.32,6.55c3.95,0,7.12-2,8.1-6.55C85.2,24.95,83,22.16,79.09,22.16Zm2.45,6.53c-.6,2.85-2.29,4.54-4.81,4.54s-3.47-2.09-2.92-4.54c.65-2.85,2.32-4.53,4.84-4.53S82.08,26.14,81.53,28.7Z",
  transform: "translate(0 0)"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M86,25.37c-.4,3,4.94,4.82,4.54,6.63C90.35,33.07,89,33,88,33H84.55l-.42,2h4.26c3.49,0,5-1.26,5.28-3,.51-3.1-4.93-4.7-4.51-6.71.14-.62.83-.93,2.34-.93h3l.44-2H91.19C87.91,22.39,86.29,23.56,86,25.37Z",
  transform: "translate(0 0)"
});

var _ref23 = /*#__PURE__*/React.createElement("polygon", {
  points: "106.97 22.39 96.35 22.39 95.91 24.4 99.84 24.4 97.59 35.02 100.37 35.02 102.62 24.4 106.55 24.4 106.97 22.39"
});

var _ref24 = /*#__PURE__*/React.createElement("polygon", {
  points: "109.94 22.39 102.7 35.02 105.48 35.02 111.03 24.89 112.14 33.01 108.16 33.01 107.07 35.02 115.24 35.02 113.27 22.39 109.94 22.39"
});

var _ref25 = /*#__PURE__*/React.createElement("polygon", {
  points: "122.17 22.39 119.37 22.39 116.69 35.02 125.23 35.02 125.67 33.01 119.91 33.01 122.17 22.39"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M137.31,24.4h3l.44-2H137c-3.27,0-4.9,1.16-5.14,3-.41,3,4.94,4.82,4.54,6.63-.25,1.06-1.55,1-2.61,1h-3.44l-.42,2h4.26c3.49,0,5-1.26,5.28-3,.51-3.1-4.93-4.7-4.51-6.71C135.1,24.72,135.79,24.4,137.31,24.4Z",
  transform: "translate(0 0)"
});

var _ref27 = /*#__PURE__*/React.createElement("polygon", {
  points: "149.93 29.56 150.33 27.7 144.79 27.7 145.49 24.4 151.85 24.4 152.27 22.39 143.13 22.39 140.44 35.02 149.59 35.02 150.02 33.01 143.66 33.01 144.38 29.56 149.93 29.56"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M160.17,22.39h-5.88L151.61,35h2.78l2.25-10.64h2.5c1.54,0,1.69.87,1.53,1.66a2.78,2.78,0,0,1-3,2.1,7.52,7.52,0,0,1-1.06,0L158.89,35h3l-2.08-5.45a4.08,4.08,0,0,0,3.61-4C163.62,23.5,162.64,22.39,160.17,22.39Z",
  transform: "translate(0 0)"
});

var _ref29 = /*#__PURE__*/React.createElement("polygon", {
  points: "174.56 22.39 169.02 32.52 167.72 22.39 164.94 22.39 166.84 35.02 170.13 35.02 177.31 22.39 174.56 22.39"
});

var _ref30 = /*#__PURE__*/React.createElement("polygon", {
  points: "176.32 35.02 179.1 35.02 181.78 22.39 178.99 22.39 176.32 35.02"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M184.84,28.7a5.33,5.33,0,0,1,5.26-4.53,10,10,0,0,1,3,.4l.25-2.13a16,16,0,0,0-2.77-.28c-3.87,0-7.61,2-8.56,6.53s1.9,6.55,5.77,6.55a20,20,0,0,0,3.12-.28l.69-2.17a13.71,13.71,0,0,1-3.38.44C185.66,33.24,184.24,31.55,184.84,28.7Z",
  transform: "translate(0 0)"
});

var _ref32 = /*#__PURE__*/React.createElement("polygon", {
  points: "192.87 35.02 202.02 35.02 202.44 33.01 196.09 33.01 196.81 29.56 202.35 29.56 202.76 27.7 197.21 27.7 197.92 24.4 204.28 24.4 204.7 22.39 195.56 22.39 192.87 35.02"
});

var _ref33 = /*#__PURE__*/React.createElement("polygon", {
  points: "62.19 18.65 205.5 18.65 205.69 17.72 62.38 17.72 62.19 18.65"
});

var SvgUsps = function SvgUsps(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "5e7a7c68-3c65-4372-ae5f-2d35b134c4ae",
    "data-name": "Layer 1",
    viewBox: "0 0 216 36.38",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUsps, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/usps.f50e3848.svg";
export { ForwardRef as ReactComponent };